<template>
    <div class="vue-tab-button">
        <button v-if="item.title" @click="handleClick" :class="{ 'active': isActive }">
            <span v-if="hasIcon" :style="`mask-image: url(${item.icon})`" class="icon"></span>
            {{ item.title }}
        </button>
    </div>
</template>

<script>
export default {
    name: "TabButton",

    props: ['selectedId', 'item'],

    computed: {
        hasIcon() {
            return !_.isEmpty(this.item.icon);
        },

        isActive() {
            return _.isEqual(this.item.id, this.selectedId);
        }
    },

    methods: {
        handleClick() {
            this.$emit('selected-tab', this.item.id);
        }
    }
}
</script>
